import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackgroundPattern = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 640 398",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "a",
			fill: "#fff",
			d: "m165.5-118.17.11-.03 52.93-17.65 26.35-35.7.1-.04 52.94-17.99 26.35-35.71.1-.03 52.94-17.3 26.34-35.71.06-.02 49.17-17.26.23.66-49.02 17.21-26.35 35.72-.11.03-52.93 17.3-26.35 35.7-.1.04-52.94 17.99-26.35 35.71-53.04 17.68-27.04 36.05-.1.04L84.5-63.26 58.22-27.99l-.1.04L9.1-10.74l-26.35 35.72-.11.03-52.93 17.3-26.35 35.7-.1.04-52.94 17.99-26.35 35.71-53.04 17.68-27.04 36.05-.1.04-52.59 17.64-26.22 35.18-.56-.41 26.35-35.36.1-.04 52.59-17.64 27.04-36.06.11-.03 52.93-17.65 26.35-35.7.1-.04 52.94-17.99 26.35-35.71.1-.03 52.94-17.3L8.66-11.33l.1-.03 49.03-17.22 26.28-35.27.11-.04 54.28-18.22 27.04-36.06Z"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 5.82,
			y: 3.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 11.64,
			y: 7.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 17.46,
			y: 11.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 23.28,
			y: 15.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 29.1,
			y: 19.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 34.92,
			y: 23.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 40.74,
			y: 27.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 46.56,
			y: 31.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 52.38,
			y: 35.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 58.2,
			y: 39,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 64.02,
			y: 42.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 69.84,
			y: 46.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 75.66,
			y: 50.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 81.48,
			y: 54.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 87.3,
			y: 58.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 93.12,
			y: 62.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 98.94,
			y: 66.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 104.76,
			y: 70.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 110.58,
			y: 74.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 116.4,
			y: 78,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 122.22,
			y: 81.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 128.04,
			y: 85.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 133.86,
			y: 89.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 139.68,
			y: 93.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 145.5,
			y: 97.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 151.32,
			y: 101.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 157.14,
			y: 105.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 162.96,
			y: 109.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 168.78,
			y: 113.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 174.6,
			y: 117,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 180.42,
			y: 120.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 186.24,
			y: 124.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 192.06,
			y: 128.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 197.88,
			y: 132.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 203.7,
			y: 136.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 209.52,
			y: 140.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 215.34,
			y: 144.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 221.16,
			y: 148.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 226.98,
			y: 152.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 232.8,
			y: 156,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 238.62,
			y: 159.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 244.44,
			y: 163.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 250.26,
			y: 167.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 256.08,
			y: 171.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 261.9,
			y: 175.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 267.72,
			y: 179.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 273.54,
			y: 183.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 279.36,
			y: 187.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 285.18,
			y: 191.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 291,
			y: 195,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 296.82,
			y: 198.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 302.64,
			y: 202.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 308.46,
			y: 206.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 314.28,
			y: 210.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 320.1,
			y: 214.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 325.92,
			y: 218.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 331.74,
			y: 222.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 337.56,
			y: 226.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 343.38,
			y: 230.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 349.2,
			y: 234,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 355.02,
			y: 237.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 360.84,
			y: 241.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 366.66,
			y: 245.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 372.48,
			y: 249.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 378.3,
			y: 253.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 384.12,
			y: 257.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 389.94,
			y: 261.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 395.76,
			y: 265.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 401.58,
			y: 269.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 407.4,
			y: 273,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 413.22,
			y: 276.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 419.04,
			y: 280.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 424.86,
			y: 284.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 430.68,
			y: 288.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 436.5,
			y: 292.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 442.32,
			y: 296.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 448.14,
			y: 300.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 453.96,
			y: 304.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 459.78,
			y: 308.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 465.6,
			y: 312,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 471.42,
			y: 315.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 477.24,
			y: 319.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 483.06,
			y: 323.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 488.88,
			y: 327.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 494.7,
			y: 331.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 500.52,
			y: 335.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 506.34,
			y: 339.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 512.16,
			y: 343.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 517.98,
			y: 347.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 523.8,
			y: 351,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 529.62,
			y: 354.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 535.44,
			y: 358.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 541.26,
			y: 362.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 547.08,
			y: 366.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 552.9,
			y: 370.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 558.72,
			y: 374.4,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 564.54,
			y: 378.3,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 570.36,
			y: 382.2,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 576.18,
			y: 386.1,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 582,
			y: 390,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 587.82,
			y: 393.9,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 593.64,
			y: 397.8,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 599.46,
			y: 401.7,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 605.28,
			y: 405.6,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 611.1,
			y: 409.5,
			href: "#a"
		}),
		/* @__PURE__ */ _jsx("use", {
			x: 616.92,
			y: 413.4,
			href: "#a"
		})
	]
});
export default SvgBackgroundPattern;
